angular.module('qbePortal').controller('CybersourcePaymentFormController', [
	'$scope',
	'$state',
	'$sce',
	'dynamicRouter',
	'Util',
	'paymentLoggerService',
	function($scope, $state, $sce, dynamicRouter, Util, paymentLoggerService) {
		var $ctrl = this;
		$scope.$root.$broadcast('loading-animation-end');

		if (window.parent && window.parent.$controllerScope) {
			$ctrl.creditCardPaymentData =
				window.parent.$controllerScope.creditCardPaymentData;
		}

		$ctrl.cybersourceEndpoint = $sce.trustAsResourceUrl(
			endpointUrls.payments.cybersourcePaymentEndpoint
		);

		paymentLoggerService.trackQuoteStatus(
			'submitting payment to Cybersource',
			'waiting for Cybersource callback',
			null
		);
	}
]);
